module.exports = __webpack_public_path__ + "static/media/bank-transfer.8223128c.svg";